"use client";

import React, { CSSProperties, ReactNode, useState } from "react";
import { handleLogin } from "@/app/firebase/auth";
import { handleRedirectResult } from "@/app/firebase/utils";
import { ANU_h1 } from "@/app/components/TextStyles";
import "@/app/styles/skip-link.css";
import { LoadingEmpty } from "./Loading";
import { useUserStore } from "@/app/providers/UserStore";

export const dynamic = "force-dynamic";

interface PageProps {
  authenticated: boolean;
  children: ReactNode;
}

const Page: React.FC<PageProps> = ({ authenticated, children }) => {
  const [loadingUser, setLoadingUser] = useState(true);
  const { user, loading } = useUserStore();

  if (!loading) {
    handleRedirectResult().then(() => {
      setLoadingUser(false);
    });
  }

  if (authenticated) {
    if (loadingUser) {
      return <LoadingEmpty />;
    }

    return user ? ContentWindow({ children: children }) : Login();
  }

  return ContentWindow({ children: children });
};

interface ContentWindowProps {
  children: ReactNode; // Expecting an input element or any child element// A label to describe the input
}
const ContentWindow: React.FC<ContentWindowProps> = ({ children }) => {
  return <>{children}</>;
};

function Login() {
  const backgroundImageStyle: CSSProperties = {
    backgroundImage: `url('/anu_campus.jpg')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100vw",
    height: "80vh",
    color: "white",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  return (
    <div className="justify-center" style={backgroundImageStyle}>
      {/* h1 required for a11y. */}
      <ANU_h1 className="sr-only text-black bg-anu-light-gold m-10 p-5">
        Sign in to manage courses
      </ANU_h1>
      <button
        className="bg-black py-2.5 px-5 border-solid border border-white hover:bg-white hover:text-black rounded"
        onClick={handleLogin}
      >
        Sign in
      </button>
    </div>
  );
}

export { Page };
